import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adyen_payment_modal_element = _resolveComponent("adyen-payment-modal-element")
  const _component_adyen_payment_modal_caption = _resolveComponent("adyen-payment-modal-caption")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    "is-visible": $props.isModalVisible,
    "show-action-close": true,
    width: "wide",
    "body-class-list": $options.modalClassList,
    "navigation-class-list": $options.modalClassList,
    onActionClose: $options.onInternalClose,
    "data-qa": "adyen-payment-modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_adyen_payment_modal_caption)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_adyen_payment_modal_element, { ref: "adyenAction" }, null, 512 /* NEED_PATCH */),
      _createVNode(_component_progress_overlay, {
        visible: _ctx.isProcessing,
        fixed: true
      }, null, 8 /* PROPS */, ["visible"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible", "body-class-list", "navigation-class-list", "onActionClose"]))
}